import React from 'react';
import Button from './common/Button';

const LoginForm = ({
	customDetails,
	mobileNumber,
	AAHandle,
	sendSpinner,
	isGetOTPDisabled,
	onMobileNumberChange,
	onAAHandleChange,
	onSendOtp,
	onToggleSheet,
	onTogglePrivacySheet,
}) => {
	return (
		<div className="container px-3">
			<div className="row mb-3">
				<div>
					<div className="row">
						<div className="col-lg-12 col-12">
							<h1
								className="fs-12 fw-600 text-start"
								style={{
									color: customDetails?.headingColor,
									fontFamily: customDetails?.fontFamily,
									textAlign: 'left',
									fontSize: customDetails?.fontSize,
								}}
							>
								MANAGE CONSENT
							</h1>
							<p
								className="fs-12 fw-500 text-start mt-4"
								style={{
									color: customDetails?.textColor,
									fontFamily: customDetails?.fontFamily,
									textAlign: 'left',
								}}
							>
								Enter your registered mobile number or AA handle to verify and
								manage your consents
							</p>
							<p
								className="fs-12 fw-500 text-start mt-4"
								style={{
									color: customDetails?.textColor,
									fontFamily: customDetails?.fontFamily,
								}}
							>
								OTP will be sent to your mobile number
							</p>
						</div>

						<div className="col-12">
							<div className="input-group mb-3" style={{ height: '50px' }}>
								<input
									type="number"
									inputMode="decimal"
									value={mobileNumber}
									onChange={(e) => onMobileNumberChange(e.target.value)}
									onKeyDown={(e) => {
										if (e.key === 'Enter' && !isGetOTPDisabled) {
											e.preventDefault();
											onSendOtp();
										}
									}}
									autoFocus
									className="form-control ps-3"
									placeholder="Enter Mobile number"
									aria-label="number"
									aria-describedby="basic-addon1"
									style={{
										fontFamily: customDetails?.fontFamily,
										width: '25%',
										display: 'block',
										marginLeft: 0,
									}}
								/>
							</div>
						</div>

						<div className="col-12">
							<p
								style={{
									color: customDetails?.textColor,
									fontFamily: customDetails?.fontFamily,
								}}
							>
								OR
							</p>
						</div>

						<div className="col-12 mb-5">
							<div className="input-group mb-3" style={{ height: '50px' }}>
								<input
									type="text"
									value={AAHandle}
									onChange={(e) => onAAHandleChange(e.target.value)}
									onKeyDown={(e) => {
										if (e.key === 'Enter' && !isGetOTPDisabled) {
											e.preventDefault();
											onSendOtp();
										}
									}}
									className="form-control ps-3"
									placeholder="Enter AA Handle"
									aria-label="number"
									aria-describedby="basic-addon1"
									style={{
										fontFamily: customDetails?.fontFamily,
										paddingRight: '70px',
									}}
								/>
								<span className="input-fix-finvu">@finvu</span>
							</div>
						</div>

						<div className="col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-12 d-flex justify-content-center">
							<Button
								type="button"
								disabled={isGetOTPDisabled}
								onClick={onSendOtp}
								color={customDetails?.primaryBtnColor}
								fontFamily={customDetails?.fontFamily}
								fontSize={customDetails?.fontSize}
								size="medium"
								padding="default"
								style={{
									height: customDetails?.btnHeight,
									width: customDetails?.btnWidth,
									borderRadius: customDetails?.borderRadius,
									opacity: 1,
								}}
								className="float-end fs-16 fw-600"
							>
								{sendSpinner ? (
									<div
										className="snippet"
										style={{ display: 'flex', justifyContent: 'center' }}
										data-title=".dot-pulse"
									>
										<div className="stage">
											<div className="dot-pulse-btn"></div>
										</div>
									</div>
								) : (
									'Get OTP'
								)}
							</Button>
						</div>
					</div>
				</div>
			</div>

			<div className="col">
				<div className="col-lg-6 offset-lg-3 col-12">
					<p
						className="fs-12 fw-600"
						style={{
							color: customDetails?.textColor,
							bottom: '0px',
							fontFamily: customDetails?.fontFamily,
						}}
					>
						By proceeding you agree to Finvu's
						<br />
						<span style={{ display: 'inline-flex', alignItems: 'baseline', flexWrap: 'wrap' }}>
							<button
								disabled={sendSpinner}
								className="btn btn-link"
								onClick={onToggleSheet}
								style={{
									fontFamily: customDetails?.fontFamily,
									color: customDetails?.primaryBtnColor,
									fontSize: customDetails?.fontSize,
									padding: '0',
									textDecoration: 'underline',
									border: 'none',
									background: 'none'
								}}
							>
								Terms and Conditions
							</button>
							<span style={{ 
								margin: '0 6px', 
								color: customDetails?.textColor,
								fontSize: customDetails?.fontSize,
								fontFamily: customDetails?.fontFamily
							}}>
								&
							</span>
							<button
								disabled={sendSpinner}
								className="btn btn-link"
								onClick={onTogglePrivacySheet}
								style={{
									fontFamily: customDetails?.fontFamily,
									color: customDetails?.primaryBtnColor,
									fontSize: customDetails?.fontSize,
									padding: '0',
									textDecoration: 'underline',
									border: 'none',
									background: 'none'
								}}
							>
								Privacy Policy
							</button>
						</span>
					</p>
				</div>
			</div>
		</div>
	);
};

export default LoginForm;
